// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./SquarePlayIcon.data";

export const SquarePlayIcon = createIcon("SquarePlayIcon", iconNode);
